<div class="tabs" #tabsContainer>
  <div class="circle-indicator" #indicator></div>
  <ng-container *ngIf="tabs?.length > 0">
    <div
      class="tab"
      *ngFor="let tab of tabs; let i = index"
      [class.active]="selectedIndex === i"
      [ngStyle]="tabStyle"
      (click)="selectTab(i, $event)"
    >
      <label> {{ tab }}</label>
      <div class="tab-item-bg"></div>
    </div>
  </ng-container>
</div>
